import React, { useState } from 'react';
import { Plus, Check } from 'react-feather';
import TextArea from 'components/shared/debouncedTextArea';
import { Text, TEXT_VARIANTS } from 'ui/Typography';
import { Button } from 'ui';
import ActionButtons from './ActionButtons';
import Feedback from './Feedback';

const GeneratedMultipleChoice = ({
  index,
  question,
  added,
  answerChoices,
  addQuestionToSection,
  sendLLMFeedback,
  back,
  tryAgain,
  answersOnly = false,
}) => {
  const [questionText, setQuestionText] = useState(question);
  const [rawChoices, setRawChoices] = useState(answerChoices);
  const [questionAdded, setQuestionAdded] = useState(added);

  const addToSection = () => {
    setQuestionAdded(true);
    addQuestionToSection(index, questionText, rawChoices);
  };

  const sendFeedback = score => {
    return sendLLMFeedback(index, score);
  };

  const renderQuestionAndAnswerChoiceFields = () => (
    <>
      <Text
        variant={TEXT_VARIANTS.BODY}
        component="label"
        htmlFor={`question${index}`}
      >
        {t('lessons.editor.elements.question')}
      </Text>
      <Text
        variant={TEXT_VARIANTS.BODY_LIGHT}
        id={`question${index}`}
        component={TextArea}
        className=" EditorElement-input UnifiedPromptInput c-white-background mb-8 lh-24"
        value={questionText}
        onChange={value => setQuestionText(value)}
        singleLine
      />
      <Text
        variant={TEXT_VARIANTS.BODY}
        component="label"
        htmlFor={`answerChoices${index}`}
      >
        {t('questions.question.select_option.prompt')}
      </Text>
      <Text
        variant={TEXT_VARIANTS.BODY_LIGHT}
        id={`answerChoices${index}`}
        component={TextArea}
        className="GeneratedQuestions--input EditorElement-input UnifiedPromptInput c-white-background mb-8 lh-24"
        value={rawChoices}
        onChange={value => setRawChoices(value)}
      />
    </>
  );

  if (answersOnly) {
    return (
      <>
        {renderQuestionAndAnswerChoiceFields()}
        <div className="d-f jc-sb ai-b">
          <Feedback sendFeedback={sendFeedback} />
          <ActionButtons
            back={back}
            tryAgain={() => tryAgain(questionText)}
            primaryAction={addToSection}
            primaryActionText={t(
              'lessons.editor.element_assistant.actions.add_to_section',
            )}
            icon={<Plus className="AddToSectionIcon Icon Button-icon" />}
          />
        </div>
      </>
    );
  }

  return (
    <div className="GeneratedQuestions--option">
      {renderQuestionAndAnswerChoiceFields()}
      <div className="d-f jc-sb ai-c mt-8">
        <Feedback sendFeedback={sendFeedback} />
        {questionAdded ? (
          <div className="d-f ai-c pt-8 pb-4 pr-24 pl-0" aria-live="polite">
            <Check size={18} className="c-success mr-8" />
            <Text variant={TEXT_VARIANTS.BODY}>
              {t('lessons.editor.element_assistant.actions.added')}
            </Text>
          </div>
        ) : (
          <Button className="float-right" onClick={addToSection}>
            <Plus className="Icon Button-icon" />
            {t('lessons.editor.element_assistant.actions.add_to_section')}
          </Button>
        )}
      </div>
    </div>
  );
};

export default GeneratedMultipleChoice;
